export const TRACK_DATE_SORT = 'created'
export const PLAYLIST_DATE_SORT = 'date'
export const TITLE_SORT = 'name'
export const ARTIST_SORT = 'artist'
export const RELEASE_DATE_SORT = 'release date'
export type SORT =
  | 'created'
  | 'date'
  | 'name'
  | 'artist'
  | 'id' // TODO: update types in mobile project and remove "string" here
  | string
export const SORT_DIRECTION_ASC = 'SORT_DIRECTION_ASC'
export const SORT_DIRECTION_DESC = 'SORT_DIRECTION_DESC'
export type SORT_DIRECTION =
  | 'SORT_DIRECTION_ASC'
  | 'SORT_DIRECTION_DESC' // TODO: update types in mobile project and remove "string" here
  | string
type SortOption = {
  value: SORT
  text: string
  dir?: SORT_DIRECTION
}
export const CHANNEL_DATE_SORT = 'CHANNEL_DATE_SORT'
export const CHANNEL_TITLE_SORT = 'CHANNEL_TITLE_SORT'
export const CHANNEL_CUSTOM_SORT = 'CHANNEL_CUSTOM_SORT'
export type CHANNEL_SORT =
  | 'CHANNEL_DATE_SORT'
  | 'CHANNEL_TITLE_SORT'
  | 'CHANNEL_CUSTOM_SORT'
export const SLIDER_DURATION_RANGE = '0-600'
const genericSortTypes = [
  {
    value: 'name',
    text: 'name',
  },
  {
    value: 'date',
    text: 'date',
  },
  {
    value: 'score',
    text: 'relevance',
  },
]
export const defaultSortTypes: string[] = genericSortTypes.map(t => t.value)
export const extendedSortTypes: SortOption[] = [
  ...genericSortTypes,
  {
    value: 'artist',
    text: 'artist',
  },
  {
    value: 'year',
    text: 'year',
  }, // TODO: re-enable when API works
  // { value: 'Release Date', text: 'release date' },
]
export const extendedSortTypesWithReverse: SortOption[] = [
  {
    value: 'artist',
    text: 'Artist: A-Z',
    dir: SORT_DIRECTION_ASC,
  },
  {
    value: 'artist',
    text: 'Artist: Z-A',
    dir: SORT_DIRECTION_DESC,
  },
  {
    value: 'date',
    text: 'Newest',
    dir: SORT_DIRECTION_DESC,
  },
  {
    value: 'date',
    text: 'Oldest',
    dir: SORT_DIRECTION_ASC,
  },
  {
    value: 'name',
    text: 'Name: A-Z',
    dir: SORT_DIRECTION_ASC,
  },
  {
    value: 'name',
    text: 'Name: Z-A',
    dir: SORT_DIRECTION_DESC,
  },
  {
    value: 'score',
    text: 'Relevance',
    dir: SORT_DIRECTION_DESC,
  },
  {
    value: 'year',
    text: 'Year: Newest',
    dir: SORT_DIRECTION_DESC,
  },
  {
    value: 'year',
    text: 'Year: Oldest',
    dir: SORT_DIRECTION_ASC,
  },
  {
    value: 'Release Date',
    text: 'Release Date: Newest',
    dir: SORT_DIRECTION_DESC,
  },
  {
    value: 'Release Date',
    text: 'Release Date: Oldest',
    dir: SORT_DIRECTION_ASC,
  },
]
export const artistSortTypesWithReverse = [
  {
    value: 'name',
    text: 'Name: A-Z',
    dir: SORT_DIRECTION_ASC,
  },
  {
    value: 'name',
    text: 'Name: Z-A',
    dir: SORT_DIRECTION_DESC,
  },
  {
    value: 'score',
    text: 'Relevance',
    dir: SORT_DIRECTION_DESC,
  },
]
